module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ke-9ea890912ffd2f80e7a3182a0c325afc.svg";